import { apiFetch } from '../lib/apiFetch';

export interface ChatResponse {
  answer: string;
  data: Record<string, unknown>[] | null;
  chartConfig: {
    type: 'bar' | 'line' | 'pie' | 'composed' | 'table';
    measures: string[];
    dimensions: string[];
  } | null;
  cubeQuery: Record<string, unknown> | null;
  error?: string;
}

export async function sendChatMessage(question: string): Promise<ChatResponse> {
  const res = await apiFetch('/api/v1/chat', {
    method: 'POST',
    body: JSON.stringify({ question }),
  });
  if (!res.ok) throw new Error('Failed to send message');
  return res.json();
}

export async function getChatStatus(): Promise<{ available: boolean }> {
  const res = await apiFetch('/api/v1/chat/status');
  if (!res.ok) return { available: false };
  return res.json();
}
